<template>
  <BaseSelect v-bind="$attrs"
              :value="value"
              :options="locales"
              textKey="key"
              @input="onInput"
              :getOptionText="getOptionText">
    <template v-slot:option="{option, getOptionLabel}">
      <span v-if="option.key === currentLocale">
        {{ getOptionLabel(option) }}
      </span>
      <router-link v-else
                   :to="getRoute(option)">
        {{ getOptionLabel(option) }}
      </router-link>
    </template>
  </BaseSelect>
</template>

<script>
  export default {
    name: 'LocaleSelect',
    data() {
      return {}
    },
    computed: {
      locales() {
        const storeLocales = this.$store.state.locales
        const locales = []

        for (let key in storeLocales) {
          locales.push({
            key,
            props: storeLocales[key]
          })
        }

        return locales
      },
      currentLocale() {
        return this.$store.state.currentLocale
      },
      value() {
        return this.locales.find(item => item.key === this.currentLocale)
      }
    },
    methods: {
      onInput(event) {
        const currentLocale = this.locales.find(locale => locale.key === event.key)
        if (currentLocale) {
          this.$store.dispatch('changeCurrentLocale', event.key)
        }
      },
      getOptionText(option) {
        return option.props.name
      },
      getRoute(option) {
        let name = this.$route.name

        if (option.key === 'ua') {
          if (!name.endsWith('-double')) {
            name += '-double'
          }

          return {
            name,
            params: {...this.$route.params, lang: option.key},
            query: {...this.$route.query}
          }
        } else {
          if (name.endsWith('-double')) {
            name = name.replace('-double', '')
          }

          return {
            name,
            params: {...this.$route.params, lang: option.key},
            query: {...this.$route.query}
          }
        }
      }
    }
  }
</script>

<style lang="less">

</style>
